(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("angular-ui-router"));
	else if(typeof define === 'function' && define.amd)
		define("opkOAuth", ["angular", "angular-ui-router"], factory);
	else if(typeof exports === 'object')
		exports["opkOAuth"] = factory(require("angular"), require("angular-ui-router"));
	else
		root["opkOAuth"] = factory(root["angular"], root["angular-ui-router"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition